import { BASE_API } from "../Config/Config";

export const fetchannouncementapi = async () => {
    try {
        const response = await fetch(
            `${BASE_API}/apis/annoceshow.php`,
            {
                method: "POST",
            }
        );

        const result = await response.json();

        if (
            result.status === "success" &&
            Array.isArray(result.data)
        ) {
            return result.data;
        } else {
            return []; // always return array           
        }
    } catch (err) {
        console.error("Fetch Error:", err);
        return [];
    }
};